(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["backupprodcutrecommendation14-10-25"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-seller-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (window.jQuery && $('.owl-carousel2').length) {
    $('.owl-carousel2').owlCarousel({
      loop: true,
      margin: 2,
      nav: true,
      dots: false,
      
      responsive: {
        0: { items: 1.3 },
        600: { items: 2.4 },
        1000: { items: 4.5 },
        1200: { items:5.4  }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-products-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (window.jQuery && $('.owl-carousel3').length) {
    $('.owl-carousel3').owlCarousel({
      loop: true,
      margin: 2,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 1.3 },
        480: { items: 1.6 },
        768: { items: 2.5 },
        1024: { items: 3.5 },
        1200: { items: 5.5 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) return;

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();

      // Re-initialize Owl Carousel after AJAX load
      initOwlCarousel();
    }
  };
  request.send();
}; 

// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

// Function to initialize Owl Carousel
function initOwlCarousel() {
  $('.related-collection.owl-carousel').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: true,
    slideTransition: 'linear',
    autoplayTimeout: 3000, // ✅ must be > 0
    autoplaySpeed: 1000,
    autoplayHoverPause: false,
    responsive: {
      0: { items: 1.3 },
      480: { items: 2.2 },
      768: { items: 2.6 },
      1024: { items: 3.5 },
      1200: { items: 5.5 }
    }
  });
}

// Initialize on first load
document.addEventListener("DOMContentLoaded", initOwlCarousel);

  } catch(e) { console.error(e); }
})();
})();
